import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";

import { GetTeeSheetTemplate, ITeeSheetTemplate } from "api/rpc/2024-04/facilityAdmin/teesheet/teesheetTemplate";
import { StatusCode } from "api/protocols";

import Page from "components/page/Page";
import axios, { CancelToken } from "axios";
import DataTable from "../../../../../../components/dataTable/DataTable";
import { capitalize } from "helpers/Helpers";
import DropFilter from "components/dropdown/DropFilter";

type TemplateFilters = {
  archived: boolean;
};

export default function TeeSheetTemplates() {
  const history = useHistory();
  const { t } = useTranslation();
  const [state, setState] = useState({
    templates: undefined as ITeeSheetTemplate[],
  });

  // const columns = ["Name", "Version", "Format", "Interval", "Holes"];

  // Define filter presets here
  const [filters, setFilters] = useState<TemplateFilters>({
    archived: false,
  });

  useEffect(() => {
    const source = axios.CancelToken.source();
    void loadTemplates(source.token);
    return () => {
      source.cancel();
    };
  }, []);

  useEffect(() => {
    const source = axios.CancelToken.source();
    void loadTemplates(source.token);
  }, [filters]);

  async function loadTemplates(token?: CancelToken) {
    if (state.templates !== undefined) {
      setState(prev => ({ ...prev, templates: undefined }));
    }

    const params = {
      archived: true,
    };

    const templateRes = await GetTeeSheetTemplate(filters.archived ? params : null, token ? false : true, token);
    if (templateRes.status !== StatusCode.OK) {
      setState(prev => ({ ...prev, templates: [] }));
      return;
    }

    setState(prevState => ({
      ...prevState,
      templates: templateRes.data,
    }));
  }

  function navigateTo(url: string) {
    history.push(url);
  }

  function navigateToNewTemplate() {
    history.push("/admin/settings/tee-sheet/template/new");
  }

  const primaryAction = {
    content: t("New Template"),
    action: navigateToNewTemplate,
  };

  return (
    <Page
      title={t("Tee Sheet Templates")}
      subtitle={t("Build new tee sheet templates")}
      narrow
      primaryAction={primaryAction}
    >
      <div className="flex flex-row flex-wrap gap-4">
        <DropFilter
          title={t("Archived")}
          filterData={[{ value: true, title: t("Archived") }]}
          filterLabelPropFromData="title"
          filterIdPropFromData="id"
          filterType="Checkbox"
          applyFilters={filterReturn => setFilters(prevState => ({ ...prevState, archived: filterReturn[0]?.value }))}
        />
      </div>
      <hr className="my-8" />
      <DataTable
        columns={[
          { label: t("Name") },
          { label: t("Description") },

          { label: t("Version") },
          { label: t("Format") },
          { label: t("Holes") },
        ]}
        loading={!state.templates}
        className="ui-table ui-table-clickable"
      >
        {state.templates?.map(template => {
          return (
            <tr
              key={template.id}
              onClick={() => navigateTo("/admin/settings/tee-sheet/template/" + String(template.id))}
            >
              <td>{template.name}</td>
              <td>{template.description}</td>

              <td>{template.version}</td>
              <td>{capitalize(template.format)}</td>
              <td>{template.holes}</td>
            </tr>
          );
        })}
      </DataTable>
    </Page>
  );
}
